<template>
    <div class="pop_full" v-if="isShow">
        <div class="layout_wrap sheet_default_set">
            <div class="content_wrap">
                <div class="header_title">
                    <span class="m_title">{{ $t('work_schedule.top.label_operation_settings') }}</span>
                    <a class="close mgl_auto" @click="action_CloseWorkerSetting"> <v-icon>mdi-close</v-icon> {{ $t('common.close') }} </a>
                </div>
                <div class="h_scroll lgray black_txt">
                    <div class="w_940">
                        <!-- 부서 관리 -->
                        <DepartmentManaging @updateDepartments="updateDepartments" :departments="departments" />

                        <!-- 담당자 관리 -->
                        <EmployeeManaging @updateDepartments="updateDepartments" :departments="departments" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { workerState, closeWorkerSetting } from '../worker-state'
import DepartmentManaging from './Managing/DepartmentManaging/DepartmentManaging.vue'
import EmployeeManaging from './Managing/EmployeeManaging/EmployeeManaging.vue'

export default {
    components: {
        DepartmentManaging: DepartmentManaging,
        EmployeeManaging: EmployeeManaging
    },
    data() {
        return {
            worker: workerState,
            departments: []
        }
    },
    methods: {
        action_CloseWorkerSetting() {
            closeWorkerSetting()
        },
        updateDepartments(newDepartments) {
            this.departments = newDepartments
        }
    },
    computed: {
        isShow() {
            return this.worker.isShowWorkerSetting
        }
    }
}
</script>
